import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreatePrescriptionMutation as useChCreatePrescriptionMutationType } from "@/modules/patients/detail/prescription/ch/services/__generated__/useChCreatePrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChCreatePrescriptionMutation($input: Ch_createPrescriptionInput!) {
    ch_createPrescription(input: $input) {
      ch_Prescription {
        id
        language
        healthcareProviderId
        ...chPrescriptionFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreatePrescriptionMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreatePrescriptionMutationType>(mutation, params)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreatePrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreatePrescriptionMutation }
